const ADMINISTRATIVE_AREA_REQUIRED_COUNTRY_CODES = new Set([
  'AU',
  'CA',
  'ES',
  'MX',
  'US',
]);

// ISO regions whose postal systems do not require a postal code in a standard address.
const POSTAL_CODE_OPTIONAL_COUNTRY_CODES = new Set([
  'AE',
  'AG',
  'AO',
  'AW',
  'BF',
  'BI',
  'BJ',
  'BO',
  'BS',
  'BW',
  'BZ',
  'CF',
  'CG',
  'CI',
  'CM',
  'DJ',
  'DM',
  'ER',
  'FJ',
  'GA',
  'GD',
  'GH',
  'GM',
  'GQ',
  'GY',
  'HK',
  'IE',
  'JM',
  'KE',
  'KI',
  'KM',
  'LY',
  'ML',
  'MO',
  'MR',
  'MW',
  'NA',
  'NR',
  'QA',
  'RW',
  'SB',
  'SC',
  'SL',
  'SO',
  'SR',
  'ST',
  'SY',
  'TD',
  'TG',
  'TL',
  'TO',
  'TT',
  'TV',
  'TZ',
  'UG',
  'VU',
  'YE',
  'ZW',
]);

export interface InternationalAddressRequirements {
  administrativeAreaRequired: boolean;
  postalCodeRequired: boolean;
}

/** Country-specific requiredness shared by application validation and the Salt address form. */
export function getInternationalAddressRequirements(
  countryCode?: string | null,
): InternationalAddressRequirements {
  const normalizedCountryCode = countryCode?.trim().toUpperCase() ?? '';
  return {
    administrativeAreaRequired:
      ADMINISTRATIVE_AREA_REQUIRED_COUNTRY_CODES.has(normalizedCountryCode),
    postalCodeRequired: !POSTAL_CODE_OPTIONAL_COUNTRY_CODES.has(normalizedCountryCode),
  };
}
